// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { forwardRef, ReactNode, ComponentPropsWithoutRef } from 'react'
import { Box } from '@teamnine/pcj-ui-v2'

import * as Styled from './Styles'

export type PanelBaseProps = {
  children?: ReactNode
  p?: string
  borderRadius?: number
  useContent?: boolean
  contentMaxWidth?: number
}

export type PanelProps = PanelBaseProps & ComponentPropsWithoutRef<typeof Box>

const Panel = forwardRef<HTMLDivElement, PanelProps>(function Panel(
  { children, p, borderRadius, useContent = true, contentMaxWidth, ...rest },
  ref
) {
  return (
    <Styled.Wrapper
      ref={ref}
      p={p}
      borderRadius={borderRadius}
      {...rest}
      maxWidth={contentMaxWidth}
    >
      {useContent ? (
        <Styled.Content maxWidth={contentMaxWidth}>{children}</Styled.Content>
      ) : (
        <>{children}</>
      )}
    </Styled.Wrapper>
  )
})

Panel.displayName = 'Panel'

export default Panel
